import { AxiosResponse } from 'axios'
import httpService from '../httpService'
import { SlackUserFilter, SlackUsersResponse, } from '../redux/slackUsers/types'

const getSlackUsers = (filter?: SlackUserFilter): Promise<AxiosResponse<SlackUsersResponse>> => {
    return httpService.get(`v7/pricing/slack-users/`, {
        params: filter
    })
}
export { getSlackUsers }